import { useHotkeys } from 'react-hotkeys-hook';
export const useCopy = (callback, options) => useHotkeys('cmd+c, ctrl+c', callback, { enableOnFormTags: false, ...options });
export const useCut = (callback, options) => useHotkeys('cmd+x, ctrl+x', callback, { enableOnFormTags: false, ...options });
export const usePaste = (callback, options) => useHotkeys('cmd+v, ctrl+v', callback, { enableOnFormTags: false, ...options });
